<template>
	<CRow>
		<CModal :title="$lang.profile.DCWalletTransaction.addCredit" size="lg" :show.sync="addCreditModal" :no-close-on-backdrop="true" color="primary">
	
			<CAlert :color="messageColorModal" closeButton :show.sync="dismissCountDownModal" fade>{{ err_msg }}
			</CAlert>
	
			<CForm novalidate @submit.prevent="onSubmit" enctype='multipart/form-data'>
				<CRow class="align-items-start">
					<CCol>
						<div class="form-group">
							<label class="form__label">
									{{ $lang.profile.DCWalletTransaction.form.points }}
								</label><required_span/>
							<input type="number" :placeholder="$lang.profile.DCWalletTransaction.form.points" class="form-control" v-model="dcWalletTransactionCreate.points" />
                            <small class="error" v-if="$v.dcWalletTransactionCreate.points.$error && !$v.dcWalletTransactionCreate.points.required" >{{ $lang.profile.DCWalletTransaction.validation.required.points }}</small>
						</div>
					</CCol>
					<CCol>
						<div class="form-group">
							<label class="form__label">
									{{ $lang.profile.DCWalletTransaction.form.transactionFee }}
								</label>
							<input type="number" :placeholder="$lang.profile.DCWalletTransaction.form.transactionFee" class="form-control" v-model="dcWalletTransactionCreate.transactionFee" />
						</div>
					</CCol>
					<CCol>
						<div class="form-group">
							<label class="form__label">
									{{ $lang.profile.DCWalletTransaction.form.totalPoints }}
								</label>
							<input type="number" :placeholder="$lang.profile.DCWalletTransaction.form.totalPoints" class="form-control" v-model="dcWalletTransactionCreate.totalPoints" readonly />
						</div>
					</CCol>
				</CRow>
				<CRow class="align-items-start">
					<CCol>
						<div class="form-group">
							<label class="form__label">
								{{ $lang.profile.DCWalletTransaction.form.paymentMethod }}
							</label><required_span/>
							<input type="text" :placeholder="$lang.profile.DCWalletTransaction.form.placeholder.paymentMethod" class="form-control" v-model="dcWalletTransactionCreate.paymentMethod" />
                            
						</div>
					</CCol>
					<CCol>
						<div class="form-group">
							<label class="form__label">
									{{ $lang.profile.DCWalletTransaction.form.transactionDate }}
								</label><required_span/>
							<input type="date" :placeholder="$lang.profile.DCWalletTransaction.form.transactionDate" class="form-control" v-model="dcWalletTransactionCreate.transactionDate" />
                            <small class="error" v-if="$v.dcWalletTransactionCreate.transactionDate.$error && !$v.dcWalletTransactionCreate.transactionDate.required" >{{ $lang.profile.DCWalletTransaction.validation.required.transactionDate }}</small>
						</div>
					</CCol>
				</CRow>
				<CRow class="align-items-start">
					<CCol>
						<div class="form-group">
							<input type="checkbox" :placeholder="$lang.profile.DCWalletTransaction.form.isTrialPoints" :value="0"
                           @change="changedIsTrialPoints" v-model="dcWalletTransactionCreate.isTrialPoints"/>
						   <label class="form__label ml-2">
								{{ $lang.profile.DCWalletTransaction.form.isTrialPoints }}
							</label>
						</div>
					</CCol>
					<CCol>
						<div class="form-group">
							<label class="form__label ml-2">
								{{ $lang.profile.DCWalletTransaction.form.attachment }}
							</label>
							<input
								type="file"
								ref="attachment"
								class="form-control"
								:name="dcWalletTransactionCreate.attachment"
							/>
						</div>
					</CCol>
				</CRow>
				<CRow class="align-items-start">
					<CCol>
						<div class="form-group">
							<label class="form__label">
								{{ $lang.profile.DCWalletTransaction.form.description }}
							</label><required_span/>
							<textarea
                            class="form-control"
                            :placeholder="$lang.profile.DCWalletTransaction.form.description"
                            v-model="dcWalletTransactionCreate.description" />
                            
                            <small class="error" v-if="$v.dcWalletTransactionCreate.description.$error && !$v.dcWalletTransactionCreate.description.required" >{{ $lang.profile.DCWalletTransaction.validation.required.description }}</small>
						</div>
					</CCol>
				</CRow>
                <CRow class="align-items-start">
					<CCol>
						<div class="form-group">
                            <CButton type="submit" size="sm" color="primary" :disabled="submitted">
                                <CIcon name="cil-check-circle" />
                                {{ $lang.buttons.general.crud.submit }}
                            </CButton>						
						</div>
					</CCol>
				</CRow>
			</CForm>
			<template #footer><div :style="{ display: 'none' }"></div></template>
		</CModal>
		<CCol col="12">
			<CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>{{ err_msg }} </CAlert>
			<CCard>
				<CCardHeader>
					<div class="row">
						<CCol sm="6" class="align-self-center">
							<strong>Wallet Transaction List</strong>
						</CCol>
						<CCol sm="6" class="align-self-center">
							<div class="text-sm-right mt-3 mt-sm-0">
								<CButton
									class="mr-2"
									color="success"
									v-c-tooltip="$lang.profile.payment.label.addCredit"
									v-on:click="addCreditOpenModal()"
								>
									<i class="fas fa-plus"></i>
								</CButton>
							</div>
						</CCol>
					</div>
				</CCardHeader>
				<CCardBody>
					<v-server-table 
						:key="tableKey" 
						:url="module.api.list" 
						:columns="columns" 
						:options="options"
						ref="myTable" 
						:data="data" 
						@loaded="onDataLoaded">
						<template #actions="data">
							<CButton color="success" v-c-tooltip="$lang.buttons.general.crud.details" v-on:click="detailsTableRow(data.row.id)">
								<i class="fas fa-clipboard-list"></i>
							</CButton>
						</template>
					</v-server-table>
				</CCardBody>
			</CCard>
		</CCol>
	</CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { DCWalletTransaction } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";
import store from "@/store/store";
import required_span from "../../../components/layouts/general/required-span";
import { required } from "vuelidate/lib/validators";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
	name: "DCWalletTransaction",
	mixins: [Mixin],
	components: {
		VueJsonToCsv,
		required_span,
	},
	data() {
		return {
			messageColor: "success",
			messageColorModal: "danger",
			err_msg: "",
			alertMessage: "",
			showAlert: false,
			dismissCountDownModal: 0,
			dismissCountDown: 0,
			dismissCountDownS: 0,
			self: this,
			activePage: 1,
			module: DCWalletTransaction,
			json_data: [],
			json_label: {},
			json_title: "",
			tableKey: 0, // Add a key to force table reload
			data: [],
			user_id: this.$route.params.id,
			addCreditModal: false,
			submitted: false,
			userId: null,
            initialFormState: {
                points: null,
                transactionFee: null,
                totalPoints: null,
                paymentMethod: '',
                transactionDate: '',
                isTrialPoints: false,
                attachment: null,
                description: '',
            },
			dcWalletTransactionCreate: {
				totalPoints: "",
				points: "",
				transactionFee: "",
				paymentMethod: "",
				transactionDate: "",
				attachment:[],
				isTrialPoints:"",
				description:"",
				userType:"User",
				isAdminSideTransaction: 1,
				transactionType:"Credit",
				status:"Success",
			},
			columns: [
				this.$lang.profile.DCWalletTransaction.table.columns.transactionId,
				this.$lang.profile.DCWalletTransaction.table.columns.transactionType,
				this.$lang.profile.DCWalletTransaction.table.columns.isTrialPoints,
				this.$lang.profile.DCWalletTransaction.table.columns.transactionDate,
				this.$lang.profile.DCWalletTransaction.table.columns.points,
				this.$lang.profile.DCWalletTransaction.table.columns.gst,
				this.$lang.profile.DCWalletTransaction.table.columns.transactionFee,
				this.$lang.profile.DCWalletTransaction.table.columns.totalPoints,
				this.$lang.profile.DCWalletTransaction.table.columns.balancePoints,
				this.$lang.profile.DCWalletTransaction.table.columns.actions
				// this.$lang.profile.DCWalletTransaction.table.columns.paymentMethod,
				// this.$lang.profile.DCWalletTransaction.table.columns.description,
				// this.$lang.profile.DCWalletTransaction.table.columns.currencyId,
				// this.$lang.profile.DCWalletTransaction.table.columns.isAdminSideTransaction,

			],
			options: {
				headings: {
					transactionId: this.$lang.profile.DCWalletTransaction.table.transactionId,
					transactionType: this.$lang.profile.DCWalletTransaction.table.transactionType,
					isTrialPoints: this.$lang.profile.DCWalletTransaction.table.isTrialPoints,
					transactionDate: this.$lang.profile.DCWalletTransaction.table.transactionDate,
					points: this.$lang.profile.DCWalletTransaction.table.points,
					gst: this.$lang.profile.DCWalletTransaction.table.gst,
					transactionFee: this.$lang.profile.DCWalletTransaction.table.transactionFee,
					totalPoints: this.$lang.profile.DCWalletTransaction.table.totalPoints,
					balancePoints: this.$lang.profile.DCWalletTransaction.table.balancePoints,
					actions: this.$lang.profile.DCWalletTransaction.table.actions
					// paymentMethod: this.$lang.profile.DCWalletTransaction.table.paymentMethod,
					// description: this.$lang.profile.DCWalletTransaction.table.description,
					// currencyId: this.$lang.profile.DCWalletTransaction.table.currencyId,
					// isAdminSideTransaction: this.$lang.profile.DCWalletTransaction.table.isAdminSideTransaction,

				},
				sortable: [this.$lang.profile.DCWalletTransaction.table.transactionDate],
				filterable: [this.$lang.profile.DCWalletTransaction.table.transactionDate],
				perPage: 25,
				requestFunction(data) {
					const userId = this.$route.params.id;
					const requestData = {
						...data
					};
					return axios.get(this.url +"User/"+ userId, { params: requestData }).then(response => {
						this.loading = false; // Stop loading
						
						return {
							data: response.data,
							// count: response.data.count
						};
					}).catch(error => {
						this.loading = false; // Stop loading on error
						console.error("error:", error);
					});
				},
			},
		};
	},
    validations: {
        dcWalletTransactionCreate: {
            totalPoints: {
                required,
            },
            points: {
                required,
            },
            transactionDate: {
                required,
            },
            description: {
                required,
            },
        },
    },
	mounted() {
		let self = this;
		store.commit("showLoader", false);
		self.dismissCountDown = 0;
		self.dismissCountDownS = 0;
		if (localStorage.getItem("showAlert") !== "") {
			this.setAlert(true);
		}
		this.setAlert(false);
		localStorage.setItem("showAlert", "");
        self.userId = self.$route.params.id;
	},
	watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
		'dcWalletTransactionCreate.points': 'updateTotalPoints',
        'dcWalletTransactionCreate.transactionFee': 'updateTotalPoints',
	},
	methods: {
		setAlert(value) {
			this.showAlert = value;
		},
		pageChange(val) {
			this.$router.push({ query: { page: val } });
		},
		onDataLoaded(data) {
			// console.log("data.data.data",data.data.data);
		},
		addCreditOpenModal() {
			let self = this;
			self.addCreditModal = true;
		},
		updateTotalPoints() {
            const points = parseFloat(this.dcWalletTransactionCreate.points) || 0;
            const transactionFee = parseFloat(this.dcWalletTransactionCreate.transactionFee) || 0;
            this.dcWalletTransactionCreate.totalPoints = (points + transactionFee).toFixed(2);
        },
		changedIsTrialPoints(e) {
			let self = this;
			this.v = e.target.checked;
			if (this.v) {
				self.dcWalletTransactionCreate.isTrialPoints = 1;
			} else {
				self.dcWalletTransactionCreate.isTrialPoints = 0;
			}
		},
		detailsTableRow(id) {
			console.log(id);
		},
        onSubmit() {
            let self = this;
            this.$v.dcWalletTransactionCreate.$touch();
            if (this.$v.dcWalletTransactionCreate.$invalid) {
                self.submitted = false; //Enable Button
            } else {
                self.submitted = true; //Disable Button
                setTimeout(() => {
                    let formData = new FormData();
                    formData.append("totalPoints", self.dcWalletTransactionCreate.totalPoints);
                    formData.append("points", self.dcWalletTransactionCreate.points);
                    formData.append("transactionFee", self.dcWalletTransactionCreate.transactionFee);
                    formData.append("paymentMethod", self.dcWalletTransactionCreate.paymentMethod);
                    formData.append("transactionDate", self.dcWalletTransactionCreate.transactionDate);
                    formData.append("isTrialPoints", self.dcWalletTransactionCreate.isTrialPoints);
                    formData.append("description", self.dcWalletTransactionCreate.description);
                    formData.append("userType", self.dcWalletTransactionCreate.userType);
                    formData.append("isAdminSideTransaction", self.dcWalletTransactionCreate.isAdminSideTransaction);
                    formData.append("transactionType", self.dcWalletTransactionCreate.transactionType);
                    formData.append("status", self.dcWalletTransactionCreate.status);

                    const fileInput = this.$refs.attachment;
                    if (fileInput && fileInput.files && fileInput.files[0]) {
                        formData.append('attachment', fileInput.files[0]);
                    }
                    
                    axios.post('/direct-candidates/add-wallet-credit/'+self.userId, formData)
                    .then(function (response) {
                        self.submitted = false; //Enable Button
                        if (response.data.code === 200) {
                            self.addCreditModal = false;
                            self.$refs.myTable.refresh();
                            self.messageColor = "success";
                            self.err_msg = response.data.message;
                            self.dismissCountDown = 10;

                            // Reset form data after submission
                            self.dcWalletTransactionCreate = { ...self.initialFormState };

                            // Optionally reset file input
                            if (self.$refs.attachment) {
                                self.$refs.attachment.value = null;
                            }

                            // Reset the form validation state if using Vuelidate or similar
                            self.$v.$reset();

                        } else {
                            self.messageColorModal = "danger";
                            self.err_msg = response.data.message;
                            self.dismissCountDownModal = 10;
                        }
                    })
                    .catch(function (error) {
                        self.submitted = false; //Enable Button
                    });
                }, 500);
            }
        },
	},
};
</script>

